import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import LayoutWithNavbar from './LayoutWithNavBar';

const ProtectedRoute = ({ children }) => {
    const { isLoggedIn, isLoading } = useAuth();

    if (isLoading) {
        return <div>Loading...</div>; // Or any other loading indicator
    }

    if (!isLoggedIn) {
        return <Navigate to="/login" />;
    }

    return (<LayoutWithNavbar>{children}</LayoutWithNavbar>);
};

export default ProtectedRoute;
